import React, { useState, useEffect } from 'react'
import moment from 'moment';
import { Controller } from 'react-hook-form';
import ErrorMessage from 'components/common/ErrorMessage';
import { Select } from 'components/common/Select';
export const filterUnit = [
    {
        label: "Hour",
        value: "hour"
    },
    {
        label: "Minute",
        value: "minute"
    }
]

export const filterIncremental = [
    {
        label: "Minute",
        value: "minute"
    },
    {
        label: "30 Minute",
        value: "30_minute"
    },
    {
        label: "1 Hour",
        value: "1_hour"
    },
]
export const TimeInput = ({ name, rule, control, errors, onChange }) => {
    return (
        <Controller
            name={name}
            control={control}
            rules={{ required: rule }}
            render={({ field }) => (
                <div style={{ width: "100%" }}>
                    <div className="input-image">
                        <input
                            type="time"
                            name={name}
                            placeholder="hh:mm"
                            {...field}
                            value={field.value}
                            onChange={(e) => {
                                field.onChange(e.target.value);
                                onChange && onChange(e.target.value);
                            }}
                        />
                        <img src="/images/clock.png" alt="Clock Icon" className="custom-icon" />
                    </div>
                    {errors?.[name]?.message && (
                        <div style={{ marginTop: 10 }}>
                            <ErrorMessage text={errors?.[name]?.message} />
                        </div>
                    )}
                </div>
            )}
        />
    );
};

export const RateInput = ({ errors, name, control, placeholder }) => {
    return (
        <div className='w-100'>
            <Controller
                name={name}
                control={control}
                rules={{
                    required: "This field is required"
                }}
                render={({ field }) => (
                    <input className="input-in type_inp" type="number" name={name} placeholder={placeholder} {...field}
                        onChange={
                            (e) => {
                                field.onChange(parseFloat(e.target.value));
                                if (e.target.value < 0) {
                                    field.onChange(0);
                                }
                            }
                        }
                    />
                )}
            />
            {errors?.[name]?.message && <div style={{ marginTop: 10 }}><ErrorMessage text={errors?.[name]?.message} /></div>}
        </div>
    )
}

export const UnitSelect = ({ name, control }) => {
    return (
        <>
            <Controller
                name={name}
                control={control}
                render={({ field }) =>
                    <div className='select_box' style={{ width: "100%" }}>
                        <Select
                            name={name}
                            options={filterUnit || []}
                            value={field.value ? filterUnit?.find((opt) => field.value == opt.value) : ""}
                            isClearable={false}
                            disabledSearch={true}
                            onChange={(value) => {
                                field.onChange(value);
                            }}
                        />
                    </div>
                }
            />
        </>
    )
}
export const InterpreterRate = ({ control, errors, item, setValue, watch, isClient = true }) => {

    const handleNormalHoursChange = () => {
        const normalHourStartTime = watch("normal_hour_start_time");
        const normalHourEndTime = watch("normal_hour_end_time");

        if (normalHourStartTime && normalHourEndTime) {
            const normalStart = moment(normalHourStartTime, "HH:mm");
            const normalEnd = moment(normalHourEndTime, "HH:mm");

            const afterStart = moment(normalEnd).add(1, "minutes");
            const afterEnd = moment(normalStart).subtract(1, "minutes").add(1, "day");

            setValue("after_hour_start_time", afterStart.format("HH:mm"));
            setValue("after_hour_end_time", afterEnd.format("HH:mm"));
        }
    };

    const handleAfterHoursChange = () => {
        const afterHourStartTime = watch("after_hour_start_time");
        const afterHourEndTime = watch("after_hour_end_time");

        if (afterHourStartTime && afterHourEndTime) {
            const afterStart = moment(afterHourStartTime, "HH:mm");
            const afterEnd = moment(afterHourEndTime, "HH:mm");

            const normalStart = moment(afterEnd).add(1, "minutes").subtract(1, "day");
            const normalEnd = moment(afterStart).subtract(1, "minutes");

            setValue("normal_hour_start_time", normalStart.format("HH:mm"));
            setValue("normal_hour_end_time", normalEnd.format("HH:mm"));
        }
    };

    const handleChangeMinDuration = (value) => {
        if (value == "minute" || value == "30_minute") {
            setValue(`opi_normal_mins_time_unit`, 'minute')
            setValue(`vri_normal_mins_time_unit`, 'minute')
            setValue(`inperson_normal_mins_time_unit`, 'minute')
            setValue(`opi_after_mins_time_unit`, "minute");
            setValue(`vri_after_mins_time_unit`, "minute");
            setValue(`inperson_after_mins_time_unit`, "minute");
        } else {
            setValue(`opi_normal_mins_time_unit`, 'hour')
            setValue(`vri_normal_mins_time_unit`, 'hour')
            setValue(`inperson_normal_mins_time_unit`, 'hour')
            setValue(`opi_after_mins_time_unit`, "hour");
            setValue(`vri_after_mins_time_unit`, "hour");
            setValue(`inperson_after_mins_time_unit`, "hour");
        }
    }

    useEffect(() => {
        if (!item) return;
    
        // Basic Hour Info
        setValue('normal_hour_start_time', item?.normal_hour_start_time || item?.interpreter_rates?.normal_hour_start_time ||item?.vendor_rates?.normal_hour_start_time|| '');
        setValue('normal_hour_end_time', item?.normal_hour_end_time || item?.interpreter_rates?.normal_hour_end_time || item?.vendor_rates?.normal_hour_end_time ||'');
        setValue('after_hour_start_time', item?.after_hour_start_time || item?.interpreter_rates?.after_hour_start_time ||  item?.vendor_rates?.after_hour_start_time  ||'');
        setValue('after_hour_end_time', item?.after_hour_end_time || item?.interpreter_rates?.after_hour_end_time || item?.vendor_rates?.after_hour_end_time || '');
        // setValue('grace_period', item?.grace_period || item?.interpreter_rates?.grace_period || item?.vendor_rates?.grace_period || '');
    
        if (isClient) {
            setValue('incremental', item?.incremental || '');
            setValue('rush_fee', item?.rush_fee || '');
        }
    
    
        const rateSource = item?.interpretation_rates || item?.interpreter_rates || item?.vendor_rates || {};
    
        // Normal Rates
        setValue('opi_normal_rate', rateSource?.opi_normal_rate || '');
        setValue('vri_normal_rate', rateSource?.vri_normal_rate || '');
        setValue('inperson_normal_rate', rateSource?.inperson_normal_rate || '');
        setValue('opi_normal_rate_time_unit', rateSource?.opi_normal_rate_time_unit || 'hour');
        setValue('vri_normal_rate_time_unit', rateSource?.vri_normal_rate_time_unit || 'hour');
        setValue('inperson_normal_time_unit', rateSource?.inperson_normal_rate_time_unit || rateSource?.inperson_normal_time_unit|| 'hour');
        setValue('opi_normal_mins', rateSource?.opi_normal_mins || '');
        setValue('vri_normal_mins', rateSource?.vri_normal_mins || '');
        setValue('inperson_normal_mins', rateSource?.inperson_normal_mins || '');
        setValue('opi_normal_mins_time_unit', rateSource?.opi_normal_mins_time_unit || 'minute');
        setValue('vri_normal_mins_time_unit', rateSource?.vri_normal_mins_time_unit || 'minute');
        setValue('inperson_normal_mins_time_unit', rateSource?.inperson_normal_mins_time_unit || 'minute');
    
        // After Hour Rates
        setValue('opi_after_rate', rateSource?.opi_after_rate || '');
        setValue('vri_after_rate', rateSource?.vri_after_rate || '');
        setValue('inperson_after_rate', rateSource?.inperson_after_rate || '');
        setValue('opi_after_rate_time_unit', rateSource?.opi_after_rate_time_unit || 'hour');
        setValue('vri_after_rate_time_unit', rateSource?.vri_after_rate_time_unit || 'hour');
        setValue('inperson_after_time_unit', rateSource?.inperson_after_rate_time_unit || rateSource?.inperson_after_time_unit|| 'hour');
        setValue('opi_after_mins', rateSource?.opi_after_mins || '');
        setValue('vri_after_mins', rateSource?.vri_after_mins || '');
        setValue('inperson_after_mins', rateSource?.inperson_after_mins || '');
        setValue('opi_after_mins_time_unit', rateSource?.opi_after_mins_time_unit || 'minute');
        setValue('vri_after_mins_time_unit', rateSource?.vri_after_mins_time_unit || 'minute');
        setValue('inperson_after_mins_time_unit', rateSource?.inperson_after_mins_time_unit || 'minute');
    
    }, [item, isClient]);


    return (
        <>
            <hr />
            <h3 className='fst-italic fw-bold text-center mt-3'>Rates</h3>
            <br />
            <br />

            {/* Normal Hours */}
            <div className="row-primary m-0 row-r justify-content-between flex-row">
                <h2 className='fst-italic fw-bold mt-0'>Normal Hours </h2>
            </div>
            <div className="rate foam_page_row">
                <div className="row-primary">
                    <h2>Start Time*</h2>
                    <TimeInput
                        errors={errors}
                        control={control}
                        name="normal_hour_start_time"
                        rule="Please select start time"
                        onChange={handleNormalHoursChange}
                    />
                </div>

                <div className="row-primary">
                    <h2>End Time*</h2>
                    <TimeInput
                        errors={errors}
                        control={control}
                        name="normal_hour_end_time"
                        rule="Please select End time"
                        onChange={handleNormalHoursChange}
                    />
                </div>
            </div>

            {/* After Hours */}
            <div className="row-primary m-0 row-r justify-content-between flex-row">
                <h2 className='fst-italic fw-bold mt-0'>After Hours </h2>
            </div>
            <div className="rate foam_page_row">
                <div className="row-primary">
                    <h2>Start Time*</h2>
                    <TimeInput
                        errors={errors}
                        control={control}
                        name="after_hour_start_time"
                        rule="Please select start time"
                        onChange={handleAfterHoursChange}
                    />
                </div>

                <div className="row-primary">
                    <h2>End Time*</h2>
                    <TimeInput
                        errors={errors}
                        control={control}
                        name="after_hour_end_time"
                        rule="Please select End time"
                        onChange={handleAfterHoursChange}
                    />
                </div>
            </div>

            {/* Grace Period */}
            <div className='foam_page_row mt-3'>
                {/* <div className="row-primary">
                    <h2>Cancellation Grace Period(Hrs)</h2>
                    <div className='w-100'>
                        <Controller
                            name="grace_period"
                            control={control}
                            rules={{ required: "Please enter Grace Period" }}
                            render={({ field }) => (
                                <input className="input-in type_inp"
                                    type="number"
                                    name='grace_period'
                                    placeholder='Grace Period' required
                                    {...field}
                                    onChange={
                                        (e) => {
                                            field.onChange(parseFloat(e.target.value));
                                            if (e.target.value < 0) {
                                                field.onChange(0);
                                            }
                                        }
                                    }
                                />
                            )}
                        />
                        {errors?.grace_period?.message && <div style={{ marginBottom: 10 }}><ErrorMessage text={errors?.grace_period?.message} /></div>}
                    </div>
                </div> */}
                {isClient &&
                    <div className="row-primary">
                        <h2>Incremental *</h2>
                        <Controller
                            name="incremental"
                            control={control}
                            render={({ field }) =>
                                <div className='select_box' style={{ width: "100%" }}>
                                    <Select
                                        name="incremental"
                                        options={filterIncremental || []}
                                        value={field.value ? filterIncremental?.find((opt) => field.value == opt.value) : ""}
                                        isClearable={false}
                                        disabledSearch={true}
                                        onChange={(value) => {
                                            field.onChange(value);
                                            handleChangeMinDuration(value)
                                        }}
                                    />
                                </div>
                            }
                        />
                    </div>
                }

            {isClient &&
                    <div className="row-primary">
                        <h2>Rush Fee *</h2>
                        <div style={{ width: "100%" }}>
                            <Controller
                                name="rush_fee"
                                control={control}
                                rules={{ required: "Please enter rush fee" }}
                                render={({ field }) => (
                                    <input className="input-in type_inp" type="number" name='rush_fee' placeholder='Rush fee' {...field}
                                        onChange={
                                            (e) => {
                                                field.onChange(parseFloat(e.target.value));
                                                if (e.target.value < 0) {
                                                    field.onChange(0);
                                                }
                                            }
                                        }
                                    />
                                )}
                            />
                            {errors?.rush_fee?.message &&
                                <div style={{ marginBottom: 10 }}>
                                    <ErrorMessage text={errors?.rush_fee?.message} />
                                </div>
                            }
                        </div>
                    </div>
              
            }
            
            </div>

            <div className='w-100'>
                <h2 className='text-center my-3 fw-bold fst-italic'>Normal Hours*</h2>

                <div className='template rate_container'>
                    <div className="row-primary align-items-end inner">
                        <h2 className='mb-3 my-0'>Rates:</h2>
                        <div className='Inter_rate_row'>
                            <h4>OPI</h4>
                            <div className='inter_wrapper'>
                                <RateInput control={control} name={`opi_normal_rate`} placeholder='OPI rate' />
                                <UnitSelect control={control} name={`opi_normal_rate_time_unit`} />
                            </div>
                        </div>

                        <div className='Inter_rate_row'>
                            <h4>VRI</h4>
                            <div className='inter_wrapper'>
                                <RateInput control={control} name={`vri_normal_rate`} placeholder='VRI rate' />
                                <UnitSelect control={control} name={`vri_normal_rate_time_unit`} />
                            </div>
                        </div>

                        <div className='Inter_rate_row'>
                            <h4>In Person</h4>
                            <div className='inter_wrapper'>
                                <RateInput control={control} name={`inperson_normal_rate`} placeholder='In person rate' />
                                <UnitSelect control={control} name={`inperson_normal_time_unit`} />
                            </div>
                        </div>
                    </div>

                    <div className="row-primary align-items-end inner">
                        <h2 className='mb-3 my-0'>Minimum:</h2>
                        <div className='Inter_rate_row'>
                            <div className='inter_wrapper'>
                                <RateInput errors={errors} control={control} name={`opi_normal_mins`} placeholder='OPI minimun' />
                                <UnitSelect control={control} name={`opi_normal_mins_time_unit`} />
                            </div>
                        </div>

                        <div className='Inter_rate_row'>
                            <div className='inter_wrapper'>
                                <RateInput errors={errors} control={control} name={`vri_normal_mins`} placeholder='VRI minimun' />
                                <UnitSelect control={control} name={`vri_normal_mins_time_unit`} />
                            </div>
                        </div>

                        <div className='Inter_rate_row'>
                            <div className='inter_wrapper'>
                                <RateInput errors={errors} control={control} name={`inperson_normal_mins`} placeholder='In person minimun' />
                                <UnitSelect control={control} name={`inperson_normal_mins_time_unit`} />
                            </div>
                        </div>
                    </div>
                </div>

                <h2 className='text-center my-3 fw-bold fst-italic'>After Hours*</h2>

                <div className='template rate_container'>
                    <div className="row-primary align-items-end inner">
                        <h2 className='mb-3 my-0'>Rates:</h2>
                        <div className='Inter_rate_row'>
                            <h4>OPI</h4>
                            <div className='inter_wrapper'>
                                <RateInput control={control} name={`opi_after_rate`} placeholder='OPI rate' />
                                <UnitSelect control={control} name={`opi_after_rate_time_unit`} />
                            </div>
                        </div>

                        <div className='Inter_rate_row'>
                            <h4>VRI</h4>
                            <div className='inter_wrapper'>
                                <RateInput control={control} name={`vri_after_rate`} placeholder='VRI rate' />
                                <UnitSelect control={control} name={`vri_after_rate_time_unit`} />
                            </div>
                        </div>

                        <div className='Inter_rate_row'>
                            <h4>In Person</h4>
                            <div className='inter_wrapper'>
                                <RateInput control={control} name={`inperson_after_rate`} placeholder='In person rate' />
                                <UnitSelect control={control} name={`inperson_after_time_unit`} />
                            </div>
                        </div>
                    </div>

                    <div className="row-primary align-items-end inner">
                        <h2 className='mb-3 my-0'>Minimum:</h2>
                        <div className='Inter_rate_row'>
                            <div className='inter_wrapper'>
                                <RateInput errors={errors} control={control} name={`opi_after_mins`} placeholder='OPI minimun' />
                                <UnitSelect control={control} name={`opi_after_mins_time_unit`} />
                            </div>
                        </div>

                        <div className='Inter_rate_row'>
                            <div className='inter_wrapper'>
                                <RateInput errors={errors} control={control} name={`vri_after_mins`} placeholder='VRI minimun' />
                                <UnitSelect control={control} name={`vri_after_mins_time_unit`} />
                            </div>
                        </div>

                        <div className='Inter_rate_row'>
                            <div className='inter_wrapper'>
                                <RateInput errors={errors} control={control} name={`inperson_after_mins`} placeholder='In person minimun' />
                                <UnitSelect control={control} name={`inperson_after_mins_time_unit`} />
                            </div>
                        </div>
                    </div>
                </div>

                <br />
                <br />
            </div>

        </>
    )
}

export default InterpreterRate